export default __webpack_public_path__ + "static/media/skipR.80b52ed1.png";